export default __webpack_public_path__ + "static/media/hindi_health_m_1.2ea180d6.wav";